<template>
    <div class="container mt-nav z-index">
        <Head title="فراموشی کلمه عبور" />
        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto">
                <div class="box__information">
                    <Link  class="btn btn-inverse-warning fs-1 position-absolute top-2 top-0 start-0 m-2" style="margin-left: 20px !important;" href="/login">🔙</Link>

                    <div class="col-12 col-md-10">

                        <p class="text-title text-white text-center pb-3 line-height">لطفا شماره موبایلی که با ان عضو شده اید را وارد کنید</p>
                        <template v-if="form.errors.status"><div class="fs-5 alert alert-danger" role="alert">{{form.errors.status}}</div></template>

                        <form @submit.prevent="store">
                            <text-input  dir="ltr" v-model="form.mobile" :error="form.errors.mobile" class="my-3 left-text" placeHolder="شماره موبایل" />
                            <div class="mt-5 ">
                                <Link  class="float-left m-0 text-sm text-white" href="/login">بازگشت به صفحه ورود</Link>
                            </div>
                            <div class="mt-5 text-center">
                                <loading-button :loading="form.processing" class="tn border-0 btn-orange w-100-btn" type="submit">ورود</loading-button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {Head, Link} from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "../../Shared/Layouts/LayoutFirstRegister";
import TextInput from "../../Shared/Forms/TextInput";
import LoadingButton from "../../Shared/Layouts/LoadingButton";
import FlashMessages from "../../Shared/Layouts/FlashMessages";

export default {
    props : {
        showMessage: {
            type: String,
            default: 'text',
        },
    },
    components: {
        FlashMessages,
        Link,
        TextInput,
        LoadingButton,
        Head,
    },
    layout: LayoutFirstRegister,
    data() {
        return {
            form: this.$inertia.form({
                mobile: '',
            }),
            resultData : null,
            countDown : 10
        }
    },
    methods: {
        countDownTimer() {
            if(this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
        store() {
            this.form.post('/forget-password' , {
                onSuccess: (data) => {

                }
            })
        },
    },
    created(){

    },
    metaInfo() {
        return {
            meta : [
                {name : 'description' , content : 'hello is my desd'}
            ]
        }

    }
}

</script>

<style scoped>

</style>
